import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { UpdateFinanceIndividual } from "src/app/parametrage/core/model/individual/update-finance-individual";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";

@Component({
  selector: "app-update-finance-individual",
  templateUrl: "./update-finance-individual.component.html",
  styleUrls: ["./update-finance-individual.component.scss"],
})
export class UpdateFinanceIndividualComponent implements OnInit {
  @Input() individualId;

  individual: Individual;

  customer: UpdateFinanceIndividual = new UpdateFinanceIndividual();

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;
  typeCredits: TypeCredit[] = [];

  constructor(
    private _individualService: IndividualService,
    private _typeCreditService: TypeCreditService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      salaireEmprunteur: [
        0,
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      salaireConjoint: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantLoyer: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantAutreRevenu: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],

      totalEngagementActuel: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      chargeEmpruntSollicite: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantBonusDat: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      primeTrimestrielle: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      domiciliationSalaire: [true, Validators.compose([Validators.required])],
      packageSouscrit: ["AUTRE", Validators.compose([Validators.required])],
      clientEngage: [false, Validators.compose([Validators.required])],
      typeCreditSouscrit: [null, Validators.compose([Validators.nullValidator])],
      montantCreditSolicite: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      echeanceMensuelleCreditSolicite: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
    });
  }

  ngOnInit() {
    this.loadTypeCredits();
    this.getIndividualById(this.individualId);
  }

  loadTypeCredits() {
    this._typeCreditService.getListTypeCredit().subscribe(
      (data) => {
        this.typeCredits = data || [];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getIndividualById(individualId) {
    this._individualService.getIndividualById(individualId).subscribe(
      (data) => {
        this.individual = data;
        this.customer.individualId = this.individual.id;
        this.customer.montantAutreRevenu = this.individual.montantAutreRevenu;
        this.customer.montantLoyer = this.individual.montantLoyer;
        this.customer.salaireConjoint = this.individual.salaireConjoint;
        this.customer.salaireEmprunteur = this.individual.salaireEmprunteur;

        this.customer.totalEngagementActuel = this.individual.totalEngagementActuel;
        this.customer.chargeEmpruntSollicite = this.individual.chargeEmpruntSollicite;
        this.customer.montantBonusDat = this.individual.montantBonusDat;
        this.customer.primeTrimestrielle = this.individual.primeTrimestrielle;
        this.customer.domiciliationSalaire = this.individual.domiciliationSalaire;
        this.customer.packageSouscrit = this.individual.packageSouscrit;
        this.customer.clientEngage = this.individual.clientEngage == null ? false : this.individual.clientEngage;
        this.customer.typeCreditSouscrit = this.individual.typeCreditSouscrit;
        this.customer.montantCreditSolicite = this.individual.montantCreditSolicite == null ? 0 : this.individual.montantCreditSolicite;
        this.customer.echeanceMensuelleCreditSolicite = this.individual.echeanceMensuelleCreditSolicite == null ? 0 : this.individual.echeanceMensuelleCreditSolicite;
        this.onClientEngageChange();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onClientEngageChange() {
    const typeCreditCtrl = this.form2.controls["typeCreditSouscrit"];
    const montantCtrl = this.form2.controls["montantCreditSolicite"];
    const echeanceCtrl = this.form2.controls["echeanceMensuelleCreditSolicite"];
    if (this.customer.clientEngage === true) {
      typeCreditCtrl.setValidators([Validators.required]);
    } else {
      typeCreditCtrl.clearValidators();
      this.customer.typeCreditSouscrit = null;
      typeCreditCtrl.setValue(null);
      this.customer.montantCreditSolicite = 0;
      montantCtrl.setValue(0);
      this.customer.echeanceMensuelleCreditSolicite = 0;
      echeanceCtrl.setValue(0);
    }
    typeCreditCtrl.updateValueAndValidity();
  }

  update(): void {
    if (!this.verifyPackage()) {
      return;
    }

    this.spinner.show();
    this._individualService
      .updateFinance(this.customer)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  verifyPackage(): boolean {
    const packageSouscrit = this.customer.packageSouscrit;
    const salaire = Number(this.customer.salaireEmprunteur);

    let isInvalid = false;

    switch (packageSouscrit) {
      case "ESSENTIEL":
        if (salaire > 250000) isInvalid = true;
        break;
      case "CLASSIC":
        if (salaire <= 250000 || salaire > 550000) isInvalid = true;
        break;
      case "GOLD":
        if (salaire <= 550000 || salaire > 1250000) isInvalid = true;
        break;
      case "PLATINUM":
        if (salaire <= 1250000 || salaire > 2500000) isInvalid = true;
        break;
      case "INFINITE":
        if (salaire <= 2500000) isInvalid = true;
        break;
      case "PREMIUM":
        if (salaire <= 2000000) isInvalid = true;
        break;
      default:
        break;
    }

    if (isInvalid) {
      this.errorMessage = "Le salaire ne correspond pas au package souscrit";
      return false;
    }

    this.errorMessage = null;
    return true;
  }
}
